import { Paper, Typography } from "@mui/material";

const ClientPortalOverviewModule = ({ clientId, preset }) => {
  return (
    <Paper sx={{ p: 3 }}>
      <Typography
        variant="h6"
        sx={{ mb: 1 }}
      >
        Client Portal Module Placeholder
      </Typography>
      <Typography color="text.secondary">
        This module is client-scoped. Current clientId: {clientId || "-"}
      </Typography>
      <Typography
        color="text.secondary"
        sx={{ mt: 1 }}
      >
        Preset: {JSON.stringify(preset || {})}
      </Typography>
    </Paper>
  );
};

export default ClientPortalOverviewModule;
